<div class="ds admsb-tarifas">

  <div class="ds-cabecera">
    <button type="button" class="ds-btn-volver"
            title="{{ 'BTN_REGRESAR' | translate }}" (click)="regresar()">
      <img src="assets/icons/ico-volver.svg" alt="">
    </button>
    <span
      class="admsb-tarifas__titulo">{{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_TARIFAS' | translate | uppercase }}</span>
  </div>

  <div class="ds-cargando" *ngIf="cargando">
    <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i>
    <span>{{ 'LBL_CARGANDO' | translate }}</span>
  </div>

  <p-accordion [multiple]="true" styleClass="ds-accordion" *ngIf="!cargando">
    <p-accordionTab *ngFor="let canal of canales"
                    tabStyleClass="ds-card admsb-tarifas__canal"
                    contentStyleClass="admsb-tarifas__medios">
      <ng-template pTemplate="header">
        <span class="admsb-tarifas__canal-label">{{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_CANAL' | translate }}:</span>
        <span class="admsb-tarifas__canal-nombre">{{ canal.nombre }}</span>
      </ng-template>

      <div class="admsb-tarifas__medio" *ngFor="let medio of canal.medios">
        <div class="admsb-tarifas__medio-titulo">
          <span class="admsb-tarifas__canal-label">{{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_MEDIO' | translate }}:</span>
          <span class="admsb-tarifas__canal-nombre">{{ medio.nombre }}</span>
        </div>

        <p-table [value]="medio.conceptos" [paginator]="true" [rows]="10" [alwaysShowPaginator]="true"
                 styleClass="ds-tabla">
          <ng-template pTemplate="header">
            <tr>
              <th>{{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_CONCEPTO' | translate }}</th>
              <th>{{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_TARIFABASE' | translate }}</th>
              <th>{{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_TARIFAPREFERENCIAL' | translate }}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-fila>
            <tr>
              <td>{{ definicion(fila.campo)?.labelClave | translate }}</td>
              <td>{{ prefijo(fila.campo) }}{{ fila.tarifaBase }}{{ sufijo(fila.campo) }}</td>
              <td>
                <input type="text" pInputText autocomplete="off"
                       number-format-reactive
                       [(ngModel)]="fila.tarifaPreferencial"
                       [prefix]="prefijo(fila.campo)"
                       [suffix]="sufijo(fila.campo)"
                       [maxIntegerDigits]="maxEnteros(fila.campo)"
                       [maxDecimalDigits]="maxDecimales(fila.campo)">
              </td>
            </tr>
          </ng-template>
        </p-table>

        <div class="admsb-tarifas__medio-acciones">
          <button type="button" pButton class="btn-primary-outline" [disabled]="estaGuardando(medio)"
                  label="{{ 'BTN_CANCELAR' | translate }}" (click)="cancelarMedio(medio)"></button>
          <button type="button" pButton class="btn-primary-full" [disabled]="estaGuardando(medio)"
                  icon="{{ estaGuardando(medio) ? 'fa fa-refresh fa-spin fa-fw' : 'fa fa-floppy-o' }}"
                  label="{{ 'BTN_GUARDAR' | translate }}" (click)="guardarMedio(medio)"></button>
        </div>
      </div>
    </p-accordionTab>
  </p-accordion>

  <div class="ds-card ds-card--gris admsb-tarifas__vacio" *ngIf="!cargando && !canales.length">
    <img src="assets/icons/ico-dinero-circulo.svg" alt="" class="admsb-tarifas__vacio-icono">
    <span
      class="admsb-tarifas__vacio-titulo">{{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_SINTARIFASCONFIGURADAS' | translate }}</span>
    <span
      class="admsb-tarifas__vacio-texto">{{ 'ADMINISTRADORSERVICIOSBANCARIOS.MSG_SINTARIFASCONFIGURADAS' | translate }}</span>
  </div>

</div>
